import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter, Input} from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import { FacilitiesService, Facility } from "../../core/facilities/facilities.service";
import { AbstractBaseComponent } from "../../shared/abstract-base.component";
import { takeUntil, delay, catchError } from 'rxjs/operators';
import { MessageBoxComponent } from '../message-box-modal/message-box-modal.component';

@Component({
    selector: 'my-single-facility-selector',
    styleUrls: ['single-facility-selector.scss'],
    templateUrl: 'single-facility-selector.html',
})
export class SingleFacilitySelectorComponent extends AbstractBaseComponent implements OnInit, OnDestroy {

    @ViewChild('singleFacilityModal', {static: true}) singleFacilityModal: ModalDirective;
    @ViewChild(MessageBoxComponent, {static: false}) public messageBoxModal: MessageBoxComponent;

    modalHeader: string = "";
    displayText: string = "";
    errorMessage: string;

    selectedFacility: Facility;
    
    facilities: Facility[];

    @Input() singleSelectionPage = true;
    @Input() pageName = 'this page'; //Pass in as "'string'" from html to override
    @Output() selectedSingleFacilityCallback = new EventEmitter<Facility>();

    constructor(
        private facilitiesSvc: FacilitiesService       
    ){
        super();
    }
    
    show(){
        this.facilitiesSvc.selectedFacilities$
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (facilities: Facility[]) => {
                    facilities = facilities.filter(x => x.isFacility);
                    if (!this.checkSingleFacility(facilities)) {
                        // Wait until they have selected the single facility
                        return;
                    }
                    // Since we just checked that they have selected only one facility, the first in the filter should be right.
                    this.selectedFacility = facilities.filter(f => f.selected===true)[0];
                    this.selectedSingleFacilityCallback.emit(this.selectedFacility);
                   
                });
        }

    checkSingleFacility(facilities: Facility[]){
        let allFacilities = this.facilitiesSvc.allFacilities$.getValue();

        let distinctFacilities = allFacilities.filter((v,i) => allFacilities.findIndex(item => item.id == v.id) === i);
        this.facilities = distinctFacilities.filter(x => x.isFacility).sort((a,b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1: 1);
        let selectedFacilities = allFacilities.filter(f=> f.selected && f.isFacility);
        let singleSelectedFacility = selectedFacilities.length === 1;
        if(facilities.length===0){
            return false;
        }
        //Only one selected
        if (singleSelectedFacility){
            return true;
        }

        //Display dialog with selected facility in list of available facilities
        this.selectedFacility = selectedFacilities[0];
        this.singleFacilityModal.show();
        return false;
    }

    ngOnInit(): void {
        if(this.singleSelectionPage){
            this.facilitiesSvc.singleSelectedFacilityPage$.next(true);
        }

        this.singleFacilityModal.config={
            backdrop:'static',
            keyboard:false
        }
    }

    
    ngOnDestroy(){
        super.ngOnDestroy();
    }

    onClickFacility(facility: Facility){
        if (!facility) {return;}

        if (!facility.isIpAllowedToAccessFacility ){
            return;
        }

        this.facilities.forEach(fac => fac.selected = false);
        this.selectedFacility = facility;
        this.selectedFacility.selected = true;
    }

    /**
     * Close the designated modal and clean up.
     * @param modal
     */
    closeModal(modal: ModalDirective) {
        this.facilitiesSvc.selectedFacilities$.next([this.selectedFacility]);

        modal.hide();
        this.ngOnDestroy();
    }

    isFacilityDisabled(facility: Facility){
        return facility && !facility.isIpAllowedToAccessFacility;
    }

    getFacilityTooltipText(facility: Facility){
        return facility && facility.isIpAllowedToAccessFacility ? "" : "Access Denied: IP Restriction.";
    }

    setupPopUpModal(modalHeader: string, displayText: string){
        this.modalHeader = modalHeader;
        this.displayText = displayText;
        this.messageBoxModal.show();
    }
    onModalClose() {
        return;
    }
}
